import { useEffect, useRef } from 'react';
import { supabase } from '@/integrations/supabase/client';

const SYNC_INTERVAL = 5 * 60 * 1000; // 5 minutes

export const useBackgroundEmailSync = (userId: string | undefined) => {
  const isSyncingRef = useRef(false);

  useEffect(() => {
    if (!userId) return;

    const syncEmails = async () => {
      if (isSyncingRef.current) return;
      
      isSyncingRef.current = true;
      console.log('🔄 Background Email Sync: Starting...');
      
      try {
        const { data: activeAccounts } = await supabase
          .from('email_accounts')
          .select('id')
          .eq('user_id', userId)
          .eq('is_active', true);

        if (activeAccounts && activeAccounts.length > 0) {
          for (const account of activeAccounts) {
            await supabase.functions.invoke('sync-emails', {
              body: { accountId: account.id }
            });
          }
          console.log('✅ Background Email Sync: Completed for', activeAccounts.length, 'accounts');
        }
      } catch (error) {
        console.error('❌ Background Email Sync error:', error);
      } finally {
        isSyncingRef.current = false;
      }
    };

    // Initial sync after 30 seconds
    const initialTimeout = setTimeout(syncEmails, 30000);
    
    // Then sync every 5 minutes
    const syncInterval = setInterval(syncEmails, SYNC_INTERVAL);

    return () => {
      clearTimeout(initialTimeout);
      clearInterval(syncInterval);
    };
  }, [userId]);
};
